import { render, staticRenderFns } from "./Test.vue?vue&type=template&id=5b2d5ecc&"
import script from "./Test.vue?vue&type=script&lang=js&"
export * from "./Test.vue?vue&type=script&lang=js&"
import style0 from "./Test.vue?vue&type=style&index=0&id=5b2d5ecc&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b2d5ecc')) {
      api.createRecord('5b2d5ecc', component.options)
    } else {
      api.reload('5b2d5ecc', component.options)
    }
    module.hot.accept("./Test.vue?vue&type=template&id=5b2d5ecc&", function () {
      api.rerender('5b2d5ecc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Test.vue"
export default component.exports